export default "__VITE_ASSET__b2c26ead__"